<template>
  <div id="ExchangeSelect">
    <!-- 显示的数据 -->
    <div v-if="activeList.length" @click.stop="selectCoupon_fn" class="selectBar">
      <span class="selectTitle">{{activeList[0].title}}</span>
      <i>{{activeList.length}}个</i>
      <CaretUpOutlined />
      <CaretDownOutlined />
    </div>
    <div v-else class="selectBar"><figcaption>请选择兑换券</figcaption></div>
    <!-- 下拉框数据 -->
    <div class="mask" v-if="optionHeight" @click="mask_fn"></div>
    <ul :class="`coupon ${optionHeight?'active':''}`" :style="`height: ${optionHeight}px`" >
      <li v-for="(item,index) in exchangeList" :key="index" @click.stop="activeOption_fn(item,index)">
        <a-checkbox v-model:checked="item.let_checked" @click.prevent/>
        <span>{{item.title}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
  import {CaretUpOutlined,CaretDownOutlined} from '@ant-design/icons-vue';
  import {Checkbox, Modal} from 'ant-design-vue';
  export default {
    name:'ExchangeSelect',
    components: {
      CaretUpOutlined,
      CaretDownOutlined,
      [Checkbox.name]: Checkbox,
    },
    props:['options','isMultiple','sectionList','checked_b'],
    data(){
      return{
        optionHeight: 0,
        activeList: [],
        exchangeList: [],
        checked: false,
      }
    },
    inject:['convertibilityNum_fn'],
    mounted() {
      this.exchangeList = this.options;
      if(this.exchangeList.length){
        this.exchangeList.map(v=>{
          v.let_checked = false;
        })
        for(let i=0,len=this.sectionList.length;i<len;i++){
          if(this.exchangeList[i]){
            this.exchangeList[i].let_checked = true;
            this.activeList.push(this.exchangeList[i]);
          }else{
            break;
          }
        }
        this.convertibilityNum_fn(this.activeList)
      }
    },
    watch:{
      // 当优惠券展开时exchangeSelect_isShow为false，隐藏兑换券下拉框
      '$store.state.exchangeSelect_isShow':{
        handler(n){
          if(!n){
            this.optionHeight = 0;
          }
        }
      }
    },
    methods:{
      // 关闭下拉框
      mask_fn(e) {
        this.optionHeight = 0;
        if (!this.activeList.length) {
          this.$emit('update:checked_b', false)
        }
      },
      // 显示列表
      selectCoupon_fn(){
        if(this.optionHeight){
          this.optionHeight = 0;
          this.$store.commit('setExchangeSelect_isShow',false);
        }else{
          this.optionHeight = 36 * this.exchangeList.length;
          this.$store.commit('setDiscountSelect_isShow',false);
          this.$store.commit('setExchangeSelect_isShow',true);
        }
      },
      // 兑换券
      activeOption_fn(item,index) {
        item.let_checked = !item.let_checked;
        if(this.activeList.length >= this.sectionList.length && item.let_checked){
          Modal.warning({
            title: '提示',
            content: '勾选的兑换券不能超过章节数量',
            centered: true,
          });
          item.let_checked = false;
          return;
        }
        let matchingIndex = this.activeList.findIndex(v => v.id === item.id)
        if(matchingIndex === -1){
          this.activeList.push(item);
        }else{
          this.activeList.splice(matchingIndex,1);
        }
        this.convertibilityNum_fn(this.activeList)
      }
    },
  }
</script>
<style scoped lang="scss">
  #ExchangeSelect{
    position: relative;
    z-index: 10;
    width: 100%;
    display: flex;
  }
  .discountNum{
    margin-left: auto;
    color: $theme_blue;
  }
  .selectBar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    line-height: 36px;
    padding: 0 32px 0 22px;
    font-size: 16px;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    flex: 1;

    figcaption{
      color: #999;
    }

    .selectTitle{
      margin-left: 0;
      margin-right: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    i {
      color: #F76B03;
    }

    .anticon-caret-up{
      position: absolute;
      right: 12px;
      top: 8px;
      font-size: 12px;
      color: $theme_blue;
    }
    .anticon-caret-down{
      position: absolute;
      right: 12px;
      top: 15px;
      font-size: 12px;
      color: $theme_blue;
    }
  }
  .mask{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
  }
  .coupon {
    position: absolute;
    top: 40px;
    left: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    line-height: 36px;
    border-radius: 6px;
    font-size: 16px;
    transition-property: height, margin-top, opacity;
    transition-duration: .3s, .3s, 0s;
    opacity: 0;
    height: 0;
    overflow: auto;
    width: 100%;
    box-shadow: 0 2px 8px #00000026;
    cursor: pointer;
    max-height: 272px;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background-color: rgba(5, 129, 206, 0.5);
      background-image: -webkit-linear-gradient(
                      45deg,
                      rgba(255, 255, 255, 0.2) 25%,
                      transparent 25%,
                      transparent 50%,
                      rgba(255, 255, 255, 0.2) 50%,
                      rgba(255, 255, 255, 0.2) 75%,
                      transparent 75%,
                      transparent
      );
    }

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      background: transparent;
      border-radius: 10px;
    }

    &.active {
      /*height: 36px;*/
      opacity: 1;
      transition-property: height, opacity;
      transition-duration: .3s, .3s;
    }

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px 0 22px;

      span{
        margin-left: 10px;
        margin-right: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      i {
        color: #F76B03;
      }
    }
  }
</style>
